import fetch from "lib/fetch";
import type { NoteInterface } from "types/note";

interface ListResponse<T> {
    data: Array<T>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
}

type NoteResponse = { data: NoteInterface };
type NoteListResponse = { data: NoteInterface[] };
type FeedbacksResponse = { data: { notes: NoteInterface[] } };

export const getNotesRequest = (params?: HashMap<unknown>) =>
    fetch.get<ListResponse<NoteInterface>>("note", { params });

export const getFeedbacksRequest = () =>
    fetch.get<FeedbacksResponse>("note/feedbacks");

export const getNotesToUserRequest = (id: string, params?: HashMap<unknown>) =>
    fetch.get<NoteListResponse>(`note/to-user/${id}`, { params });

export const getUserNotesRequest = (id: string | undefined, params?: HashMap<unknown>) =>
    fetch.get<NoteListResponse>(`note/get-user-notes/${id}`, { params });

export const createNoteRequest = (data: HashMap<unknown>) =>
    fetch.post<NoteResponse>("note", data);
